import { Injectable } from '@angular/core';
import { FlightStatusFormData } from '@com-delta-idp/mnx-sitewide-header-ui';
import { ApplicationConfig } from '@com-delta-idp/mnx-sitewide-shared-core-smart';

@Injectable({
  providedIn: 'root'
})
export class FlightStatusUrlHelperService {
  constructor(private config: ApplicationConfig) {}

  getFlightStatusUrl(
    flightSubmitUrl: string,
    flightStatusSubmitUrl: string | undefined
  ): string {
    return flightStatusSubmitUrl || `${flightSubmitUrl}flightstatus/1/`;
  }

  getFlightScheduleUrl(
    flightSubmitUrl: string,
    flightScheduleSubmitUrl: string | undefined
  ): string {
    return flightScheduleSubmitUrl || `${flightSubmitUrl}flightschedule/`;
  }

  getFlightDate(flightDetails: FlightStatusFormData): string {
    if (!flightDetails.departureDate) return '';

    const date = new Date(flightDetails.departureDate);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  getOriginDestinationUrl(
    fromAirport: string,
    toAirport: string,
    flightDate: string,
    flightSubmitUrl: string,
    flightScheduleSubmitUrl: string | undefined
  ): string {
    return `${this.getFlightScheduleUrl(
      flightSubmitUrl,
      flightScheduleSubmitUrl
    )}${fromAirport}/${toAirport}/${flightDate}`;
  }

  getFlightNumberUrl(
    flightNumber: string,
    flightDate: string,
    flightSubmitUrl: string,
    flightStatusSubmitUrl: string | undefined
  ): string {
    return `${this.getFlightStatusUrl(
      flightSubmitUrl,
      flightStatusSubmitUrl
    )}${flightNumber}/${flightDate}/w`;
  }

  redirectToOriginDestinationUrl(
    flightDetails: FlightStatusFormData,
    flightDate: string,
    flightSubmitUrl: string,
    flightScheduleSubmitUrl: string | undefined
  ): string {
    const fromAirport = flightDetails.origin || '';
    const toAirport = flightDetails.destination || '';
    const url = this.getOriginDestinationUrl(
      fromAirport,
      toAirport,
      flightDate,
      flightSubmitUrl,
      flightScheduleSubmitUrl
    );
    window.location.href = url;
    return url;
  }

  redirectToFlightNoUrl(
    flightDetails: FlightStatusFormData,
    flightDate: string,
    flightSubmitUrl: string,
    flightStatusSubmitUrl: string | undefined
  ): string {
    const flightNumber = flightDetails.flightNumber || '';
    const url = this.getFlightNumberUrl(
      flightNumber,
      flightDate,
      flightSubmitUrl,
      flightStatusSubmitUrl
    );
    window.location.href = url;
    return url;
  }
}
